if (!customElements.get('text-with-image-switch-swiper')) {
    class TextWithImageSwitchSwiper extends HTMLElement {
        // 私有字段定义
        #swiperContainer = null;
        #switchsSwiper = null;
        #swiperInstance = null; // Swiper实例
        #switchSwiperInstance = null; // Swiper实例
        #headerHeight = 0; // 头部高度
        #switchBoxTop = 0; // switchs-box 距离文档流顶部的位置
        #scrollHandler = null; // 滚动处理程序

        constructor() {
            super();
            this._resizeHandler = this._onResize.bind(this);
            this.#scrollHandler = this._onScroll.bind(this);
        }

        connectedCallback() {
            this.#initializeSwiperContainer();
            this.#calculatePositions(); // 初始化位置计算
            window.addEventListener('resize', this._resizeHandler);
            window.addEventListener('scroll', this.#scrollHandler);
        }

        disconnectedCallback() {
            this.#destroySwiper();
            window.removeEventListener('resize', this._resizeHandler);
            window.removeEventListener('scroll', this.#scrollHandler);
        }

        _onResize() {
            this.#calculatePositions(); // 窗口大小变化时重新计算位置
            if (this.#switchSwiperInstance) {
                this.#switchSwiperInstance.update();
                setTimeout(() => {
                    this.#calculatePositions();
                }, 500);
            }
            if (this.#swiperInstance) {
                this.#swiperInstance.update();
            }
        }

        _onScroll() {
            const scrollTop = window.scrollY; // 当前页面滚动距离
            if (scrollTop > this.#switchBoxTop - this.#headerHeight) {
                this.#switchsSwiper.classList.add('sticky-on');
            } else {
                this.#switchsSwiper.classList.remove('sticky-on');
            }
        }

        #calculatePositions() {
            // 获取header的高度
            this.#headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
            // 获取 .text-with-image-switch-swiper__switchs-box 距离文档流顶部的位置
            if (this.#switchsSwiper) {
                this.#switchBoxTop = this.getBoundingClientRect().top + window.scrollY;
            }
        }

        #initializeSwiperContainer() {
            this.#switchsSwiper = this.querySelector('.text-with-image-switch-swiper__switchs-box');
            this.#swiperContainer = this.querySelector('.text-with-image-switch-swiper');

            if (this.#switchsSwiper) {
                this.#initializeSwitchSwiper();
            }

            if (this.#swiperContainer) {
                this.#initializeContentSwiper();
            }
        }

        #initializeSwitchSwiper() {
            if (this.#switchSwiperInstance) {
                return; // 防止重复初始化
            }

            const swiperParams = {
                slidesPerGroup: 1,
                slidesPerView: 'auto',
                centerInsufficientSlides: true,
                watchSlidesVisibility: true,
                breakpoints: {},
            };

            this.#switchSwiperInstance = new Swiper(this.#switchsSwiper, swiperParams);
            this.#observeSwitchSwiperChanges();
        }

        #observeSwitchSwiperChanges() {
            const targetNode = this.#switchsSwiper;
            const config = { attributes: true, subtree: true, attributeFilter: ['class'] };
            const callback = (mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.target.classList.contains('swiper-slide-thumb-active')) {
                        this.#checkTitle(mutation.target);
                        break;
                    }
                }
            };

            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        }

        #checkTitle(activeElement) {
            const activeDataSwitch = activeElement.getAttribute('data-switch');
            if (!activeDataSwitch) return;

            const titles = this.querySelectorAll('.text-with-image-switch-swiper__switchs_item_mbtitle_box .text-with-image-switch-swiper__switchs_item_title');
            titles.forEach((title) => {
                const titleDataSwitch = title.getAttribute('data-switch');
                if (titleDataSwitch === activeDataSwitch) {
                    title.classList.add('active');
                } else {
                    title.classList.remove('active');
                }
            });
        }

        #initializeContentSwiper() {
            if (this.#swiperInstance) {
                return; // 防止重复初始化
            }

            const swiperParams = {
                slidesPerView: 1,
                spaceBetween: 10,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                thumbs: {
                    swiper: this.#switchSwiperInstance,
                },
                allowTouchMove: false,
                autoHeight: true,
                on: {
                    slideChange: () => {
                        const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
                        const top = this.offsetTop - headerHeight;
                        window.scrollTo({ top: top, behavior: 'smooth' });
                    },
                },
            };

            this.#swiperInstance = new Swiper(this.#swiperContainer, swiperParams);
        }

        #destroySwiper() {
            if (this.#swiperInstance) {
                this.#swiperInstance.destroy(true, true);
                this.#swiperInstance = null;
            }
            if (this.#switchSwiperInstance) {
                this.#switchSwiperInstance.destroy(true, true);
                this.#switchSwiperInstance = null;
            }
        }
    }

    customElements.define('text-with-image-switch-swiper', TextWithImageSwitchSwiper);
}
